

import { getCSRF } from './global'

export const initialState = {
  loading: false
}

export const POST_REVERSE_PROXY_REDIRECT = 'POST_REVERSE_PROXY_REDIRECT'
export const POST_REVERSE_PROXY_REDIRECT_SUCCESS = 'POST_REVERSE_PROXY_REDIRECT_SUCCESS'
export const POST_REVERSE_PROXY_REDIRECT_ERROR = 'POST_REVERSE_PROXY_REDIRECT_ERROR'

export const postReverseProxyRedirect = data => async (dispatch, getState, { httpRequest }) => {
  dispatch({ type: POST_REVERSE_PROXY_REDIRECT })
  try {
    const csrf = await dispatch(getCSRF())
    const response = await httpRequest.post('/reverse-proxy-redirect', data, {
      headers: {
        'x-csrf-token': csrf.token
      }
    })
    dispatch(postReverseProxyRedirectSuccess())
    return Promise.resolve(response.data)
  } catch (error) {
    dispatch(postReverseProxyRedirectError(error))
    return Promise.reject(error.response)
  }
}

function postReverseProxyRedirectSuccess() {
  return { type: POST_REVERSE_PROXY_REDIRECT_SUCCESS }
}

function postReverseProxyRedirectError(error) {
  return { type: POST_REVERSE_PROXY_REDIRECT_ERROR, error }
}

const ACTION_HANDLERS = {
  [POST_REVERSE_PROXY_REDIRECT]: state => ({
    ...state,
    loading: true
  }),
  [POST_REVERSE_PROXY_REDIRECT_SUCCESS]: state => ({
    ...state,
    loading: false
  }),
  [POST_REVERSE_PROXY_REDIRECT_ERROR]: (state, { error }) => ({
    ...state,
    error,
    loading: false
  }),
}

export default function reverseProxyReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./reducers/reverse-proxy.js